import type { PostHogTrackerConfig } from './trackers/PostHogTracker';
import { PostHogTracker } from './trackers/PostHogTracker';

const posthogTracker = new PostHogTracker();

export function getPosthogTracker(): PostHogTracker {
    return posthogTracker;
}

export function updatePosthogConfig(config: Partial<PostHogTrackerConfig>): void {
    posthogTracker.updateConfig(config);
}
